import logo from './logo.svg';
import './App.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import RefundPolicy from './components/RefundPolicy';
import TermsCondition from './components/TermsCondition';
import Contact from './components/Contact';
import AccountDeletion from './components/AccountDeletion';

function App() {
  return (
    <div className="">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/Terms-and-condition" element={<TermsCondition />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/account-deletion" element={<AccountDeletion />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
